module.exports = __webpack_public_path__ + "static/media/rooibostea.ac2ccf67.jpg";